<template>
  <input
    type="text"
    maxlength="1"
    v-model="val"
    @compositionstart="compositionstart"
    @compositionend="compositionend"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="handleInput"
    @keydown.delete="$emit('delete', $event)"
    v-bind="$attrs"
    ref="input"
  />
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  watch: {
    val(v) {
      if (this.isComposing) return
      this.$emit('input', v)
    },
    value(v) {
      console.log('vvvvv', v)
      this.val = v
    },
  },
  data() {
    return {
      isComposing: false,
      val: this.value,
    }
  },
  methods: {
    compositionstart() {
      this.isComposing = true
    },
    compositionend() {
      this.isComposing = false
    },
    handleFocus(event) {
      this.$emit('focus', event)
    },
    handleInput(event) {
      console.log('handleInput', event)
      if (this.isComposing) return
      console.log('setVal', event.target.value)
      this.val = event.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 1)
    },
    handleBlur(event) {
      this.$emit('blur', event)
      if (this.isComposing) {
        this.isComposing = false
        this.handleInput(event)
      }
    },
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>
